export default function OverlappingImagesType2({ images }) {
  return (
    <div className="flex justify-center md:justify-end items-center min-w-full md:min-w-[500px]">
      <div className="relative flex justify-center items-center">
        <div className="w-64 md:w-80 h-96 bg-cover bg-center rounded-t-[50%] rounded-b-lg overflow-hidden"  style={{
          backgroundImage: `url(${images[0].url})`
        }}></div>
        <img
          src={images[1].url}
          alt="Small Oval"
          className="w-32 md:w-40 h-40 md:h-56 object-cover rounded-full absolute right-[-3rem] bottom-4 border-4 border-white"
        />
      </div>
    </div>
  );
}
